import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import EditorialBand from '../../components/public/EditorialBand.component';
import EditorialBulletList from '../../components/public/EditorialBulletList.component';
import EditorialCardGrid from '../../components/public/EditorialCardGrid.component';
import EditorialHero from '../../components/public/EditorialHero.component';
import ResponsiveVideo from '../../components/public/ResponsiveVideo.component';
import ShareholdingStats from '../../components/public/ShareholdingStats.component';
import {
  OUR_VALUES_CARDS,
  OUR_VALUES_COMMITMENTS,
  OUR_VALUES_HERO,
  OUR_VALUES_SHAREHOLDING,
  OUR_VALUES_VIDEO,
} from '../../constants/our-values-content.constants';
import Meta from '../../../utils/metaDescription';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.5rem, 4vw, 2.1rem)',
    lineHeight: 1.2,
    marginBottom: '2rem',
    textAlign: 'center',
    color: theme.palette.client.primary.extraDark,
  },
  sectionTitleOnSolid: {
    color: '#fff',
  },
  photograph: {
    width: '100%',
    height: '100%',
    minHeight: 260,
    maxHeight: 420,
    objectFit: 'cover',
    borderRadius: 16,
    display: 'block',
  },
}));

const OurValuesView: React.FC = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Meta page="valeurs" />

      <EditorialBand ground="cream" underFloatingNav>
        <EditorialHero
          title={OUR_VALUES_HERO.title}
          subtitle={OUR_VALUES_HERO.subtitle}
          lead={OUR_VALUES_HERO.lead}
        />
      </EditorialBand>

      <EditorialBand ground="plain">
        <EditorialCardGrid cards={OUR_VALUES_CARDS} columns={4} />
      </EditorialBand>

      <EditorialBand ground="tint">
        <Typography component="h2" className={classes.sectionTitle}>
          {OUR_VALUES_COMMITMENTS.title}
        </Typography>

        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={7}>
            <EditorialBulletList items={OUR_VALUES_COMMITMENTS.points} />
          </Grid>

          <Grid item xs={12} md={5}>
            <img
              className={classes.photograph}
              src={OUR_VALUES_COMMITMENTS.photograph}
              alt={OUR_VALUES_COMMITMENTS.photographAlt}
              loading="lazy"
            />
          </Grid>
        </Grid>
      </EditorialBand>

      <EditorialBand ground="solid">
        <Typography component="h2" className={`${classes.sectionTitle} ${classes.sectionTitleOnSolid}`}>
          {OUR_VALUES_SHAREHOLDING.title}
        </Typography>

        <ShareholdingStats
          stats={OUR_VALUES_SHAREHOLDING.stats}
          note={OUR_VALUES_SHAREHOLDING.note}
          illustration={OUR_VALUES_SHAREHOLDING.illustration}
          illustrationAlt={OUR_VALUES_SHAREHOLDING.illustrationAlt}
        />
      </EditorialBand>

      <EditorialBand ground="plain">
        <Typography component="h2" className={classes.sectionTitle}>
          {OUR_VALUES_VIDEO.title}
        </Typography>

        <ResponsiveVideo embedUrl={OUR_VALUES_VIDEO.embedUrl} title={OUR_VALUES_VIDEO.title} />
      </EditorialBand>
    </React.Fragment>
  );
};

export default OurValuesView;
